import React from 'react';

function UyelikSozlesmesi() {
  return (
    <div>
      {/* Breadcrumb Section */}
      <div className="breadcrumb-section breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="breadcrumb-text">
                <h1>Üyelik Sözleşmesi</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Üyelik Sözleşmesi Metni */}
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-12">
            <h5>Üyelik Şartları ve Koşulları</h5>
            <div className="terms-content">
              <ul>
                <li>
                  1- <strong>www.tipsmms.com</strong> sitesinin bir tahmin ve veri analiz platformu olduğunu, bu platformda bahis oynatılmadığını bilerek üye olduğumu kabul ve beyan ediyorum.
                </li>
                <li>
                  2- <strong>www.tipsmms.com</strong> sitesinde yer alan tahmin ve yorumların, editörlerin bilgi ve birikimleri sonucu yapmış oldukları tahminler olduğunu ve bu tahminlerin olumlu veya olumsuz sonuçlanabileceğini kabul ve beyan ediyorum.
                </li>
                <li>
                  3- <strong>www.tipsmms.com</strong> sitesinde yer alan verilerin her ne kadar güncel ve doğru veri olduğunu kabul etsem de, veriler içerisinde yanlış veya hatalı bir veri olabileceğini kabul ve beyan ediyorum.
                </li>
                <li>
                  4- <strong>www.tipsmms.com</strong> sitesinde yer alan verilere dayanarak almış olduğum bahislerin tamamen kendi sorumluğumda olduğunu ve oluşabilecek kayıplardan <strong>www.tipsmms.com</strong> sitesinin sorumlu olmadığını kabul ve beyan ediyorum.
                </li>
                <li>
                  5- <strong>www.tipsmms.com</strong> sitesinde yer alan yorum bölümlerinde; herhangi bir üyeye, editöre veya platformdan sorumlu olan kişilere hakaret içeren yorumlar da bulunmayacağımı, böyle bir olayın gerçekleşmesi durumunda üyeliğimin <strong>www.tipsmms.com</strong> tarafından fesih edilebileceğini kabul ve beyan ediyorum.
                </li>
                <li>
                  6- <strong>www.tipsmms.com</strong> sitesinde yer alan yorum bölümlerinde; üyeleri yanıltıcı yorumlar da bulunmayacağımı, böyle bir olayın gerçekleşmesi durumunda üyeliğimin <strong>www.tipsmms.com</strong> tarafından fesih edilebileceğini kabul ve beyan ediyorum.
                </li>
                <li>
                  7- <strong>www.tipsmms.com</strong> sitesinde yer alan yorum bölümlerinde; üyelere herhangi bir bahis önerisinde bulunmayacağımı, böyle bir olayın gerçekleşmesi durumunda üyeliğimin <strong>www.tipsmms.com</strong> tarafından fesih edilebileceğini kabul ve beyan ediyorum.
                </li>
                <li>
                  8- <strong>www.tipsmms.com</strong> sitesinde yer alan paketlerden satın aldığım durumda, üyelik iptalim de veya üyeliğim fesih edilmesi durumunda ücret iadesinin yapılmayacağını kabul ve beyan ederim.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UyelikSozlesmesi;
